import { render, staticRenderFns } from "./PainPoints.vue?vue&type=template&id=27063a8d&scoped=true&"
import script from "./PainPoints.vue?vue&type=script&lang=js&"
export * from "./PainPoints.vue?vue&type=script&lang=js&"
import style0 from "./PainPoints.vue?vue&type=style&index=0&id=27063a8d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27063a8d",
  null
  
)

export default component.exports